import { render, staticRenderFns } from "./PrImageUploads.vue?vue&type=template&id=f0e338c0"
import script from "./PrImageUploads.vue?vue&type=script&lang=ts"
export * from "./PrImageUploads.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports